export default "__VITE_ASSET__q9uiCAQ8__"